import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { fileModel } from '../../model-file/model.file';
import { FileService } from '../../services/api/file.service';
import { FunctionsService } from '../../services/api/functions.service';
import { CognitoService } from '../../services/cognito.service';
import { LoadingService } from '../../services/loading.service';
import { DialogAsignarEquiposComponent } from './dialog-asignar-equipos/dialog-asignar-equipos.component';
import { DialogVerEquiposComponent } from './dialog-ver-equipos/dialog-ver-equipos.component';

@Component({
  selector: 'app-asignacion-equipos',
  templateUrl: './asignacion-equipos.component.html',
  styleUrls: ['./asignacion-equipos.component.css'],
})
export class AsignacionEquiposComponent implements OnInit {
  selectedValue: string = '';
  dataItinial: fileModel[] = [];
  filtersSecction: boolean = false;
  loader: boolean = false;
  selectedFile: string | null = null;
  fileDataSource = new MatTableDataSource<fileModel>();
  estadoBtnMasivo: Number = 0;
  messageButtonOS: any = null;
  model: any;
  resultOS: any;
  fileDisplayedColumns: string[] = [
    'fileNumber',
    'fileName',
    'estadoFile',
    'date',
    'paxQuantity',
    'day',
    'tipoServicio',
    'nombreServicio',
  ];

  startDate: Date | any;
  endDate: Date | any;

  startDateSelected: Date | any;
  endDateSelected: Date | any;
  daySelected: string | null = null;
  selectFile: String | null = null;
  typeOfServiceSelected: String | null = null;
  selectService: String | null = null;
  selectDate: String | null = null;
  selectEstadoFile: String | null = null;
  selectClient: String | null = null;

  arrayDays: any[] | null = null;
  arrayFiles: any[] | null = null;
  arrayTypesOfService: any[] | null = null;
  arrayServices: any[] | null = null;
  arrayDates: any[] | null = null;
  arrayClients: any[] | null = null;
  arrayEstadoFile: any[] | null = null;

  toppings: any = new FormControl('');
  toppingList: any[] | null = null;

  usuario: string = '';

  estadoBtnEquipos: boolean = false;

  file: any;
  fileGuias: any[] = [];

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.fileDataSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.fileDataSource.sort = value;
  }
  constructor(
    public dialog: MatDialog,
    private fileService: FileService,
    private changeDetectorRefs: ChangeDetectorRef,
    private router: Router,
    public loadingService: LoadingService,
    private functions: FunctionsService,
    private userService: CognitoService,
  ) {}

  ngOnInit(): void {
    this.userService.getAuthenticatedUser().then((data) => {
      this.usuario = data.username;
      console.log('user', data.username);
    });
    this.arrayEstadoFile = ['RECONFIRMADO', 'CONFIRMADO', 'CERRADO'];
    this.loader = true;
    this.loadServices();
  }

  loadServices() {
    this.fileService.getAllActiveServicesByTypeInFiles('').subscribe((data) => {
      console.log('DATA');
      console.log(data.getAllActiveServicesByTypeInFiles);
      this.arrayDays = [
        ...new Set(
          data.getAllActiveServicesByTypeInFiles.map((item: any) => item.day),
        ),
      ];
      this.arrayFiles = [
        ...new Set(
          data.getAllActiveServicesByTypeInFiles.map(
            (item: any) => item.fileNumber,
          ),
        ),
      ];
      this.arrayTypesOfService = [
        ...new Set(
          data.getAllActiveServicesByTypeInFiles.map(
            (item: any) => item.tipoServicio,
          ),
        ),
      ];
      this.arrayServices = [
        ...new Set(
          data.getAllActiveServicesByTypeInFiles.map(
            (item: any) => item.nombreServicio,
          ),
        ),
      ];
      this.arrayDates = [
        ...new Set(
          data.getAllActiveServicesByTypeInFiles.map((item: any) => item.date),
        ),
      ];
      this.arrayClients = [
        ...new Set(
          data.getAllActiveServicesByTypeInFiles.map(
            (item: any) => item.fileName,
          ),
        ),
      ];
      this.model = data.getAllActiveServicesByTypeInFiles;
      this.fileDataSource = new MatTableDataSource(this.model);
      this.fileDataSource.paginator = this.paginator;
      this.fileDataSource.sort = this.sort;
      this.changeDetectorRefs.detectChanges();
      this.loader = false;
    });
  }

  applyFilter(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.fileDataSource.filter = filterValue;
  }

  onGo(i: string) {
    this.router.navigate(['/file', i]);
  }
  addDaysToDate(date: any, days: any): any {
    var res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
  }

  transformDate(date: String, day: String) {
    const days = date.split('/')[0];
    const months = date.split('/')[1];
    const year = date.split('/')[2];

    var tmpDate = new Date(Number(year), Number(months) - 1, Number(days));
    const dateRpst = new Date(
      this.addDaysToDate(tmpDate, Number(Number(day) - 1)),
    );
    const options: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const formattedDate = dateRpst.toLocaleDateString(options);
    return formattedDate;
  }

  changeValue(tipoFile: string | null) {
    if (tipoFile) {
      this.selectedFile = tipoFile;
      this.fileDataSource.data = this.dataItinial.filter(
        (itemFilter) => itemFilter.estadoFile === this.selectedFile,
      );
    } else {
      this.fileDataSource.data = this.dataItinial;
      this.selectedFile = 'BORRAR';
    }
  }

  showFiltersFx() {
    this.filtersSecction = !this.filtersSecction;
  }

  applyFilterSelect() {
    let dataNew: any = this.model;

    if (this.toppings.value !== '') {
      this.estadoBtnEquipos = true;
    } else {
      this.estadoBtnEquipos = false;
    }

    if (this.toppings?.value) {
      dataNew = dataNew?.filter(
        (item: any) => this.toppings.value === item.fileNumber,
      );

      this.getGuide(dataNew);
    }

    if (this.daySelected) {
      dataNew = dataNew?.filter((item: any) => item.day === this.daySelected);
    }

    if (this.selectService) {
      dataNew = dataNew?.filter(
        (item: any) => item.nombreServicio === this.selectService,
      );
    }
    if (this.typeOfServiceSelected) {
      dataNew = dataNew?.filter(
        (item: any) => item.tipoServicio === this.typeOfServiceSelected,
      );
    }
    if (this.selectDate) {
      dataNew = dataNew?.filter((item: any) => item.date === this.selectDate);
    }

    if (this.selectClient) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileName === this.selectClient,
      );
    }

    if (this.selectEstadoFile) {
      dataNew = dataNew?.filter(
        (item: any) => item.estadoFile === this.selectEstadoFile,
      );
    }

    if (this.startDateSelected && this.endDateSelected) {
      dataNew = dataNew?.filter(
        (item: any) =>
          new Date(this.startDateSelected) <=
            moment(item.dateToShow, 'DD.MM.YYYY').toDate() &&
          moment(item.dateToShow, 'DD.MM.YYYY').toDate() <=
            new Date(this.endDateSelected),
      );
    }
    this.fileDataSource.data = dataNew;
  }

  openDialogAsignarEquipos() {
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      file: this.fileDataSource.data[0],
    };
    dialogConfig.width = '65rem';
    dialogConfig.height = '38rem';

    let dialogRef = this.dialog.open(
      DialogAsignarEquiposComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      console.log('closed');
    });
  }

  openDialogVerEquipos() {
    console.log(this.fileDataSource.data[0]);

    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      file: this.fileDataSource.data[0],
    };
    dialogConfig.width = '50rem';
    dialogConfig.height = '38rem';

    let dialogRef = this.dialog.open(DialogVerEquiposComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      console.log('closed');
    });
  }

  onApplyRangeSelected() {
    console.log(this.startDate);

    console.log({
      start: this.getDateTransform(JSON.stringify(new Date(this.startDate))),
      end: this.getDateTransform(JSON.stringify(new Date(this.endDate))),
    });
    this.startDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.startDate)),
    );
    this.endDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.endDate)),
    );
    this.applyFilterSelect();
  }

  // getDataFile(){
  //     this.fileService.getItineraryEquipos(this.fileDataSource.data[0].id,).subscribe((res:any)=>{
  //       console.log(res)
  //       this.file=res.getItinerary
  //
  //     })
  //
  //
  // }

  getDateTransform(date: string) {
    const dateSeparated = date.slice(1, 11).split('-');
    const month = dateSeparated[1];
    const day = dateSeparated[2];
    const year = dateSeparated[0];
    return month + '/' + day + '/' + year;
  }

  cleanDateSelected() {
    this.startDate = null;
    this.startDateSelected = null;
    this.endDate = null;
    this.endDateSelected = null;

    this.applyFilterSelect();
  }

  getGuide(services: any) {
    console.log(this.fileDataSource.data);
    const uniqueNames = new Set<string>();

    this.fileGuias = services.filter((el: any) => {
      if (el.tipoServicio === 'GUIA') {
        const providerName = el.objProvider.nombre;

        if (!uniqueNames.has(providerName)) {
          uniqueNames.add(providerName);
          return true;
        }

        return false;
      }

      return false;
    });
  }
}
